// Helps to set the field for the column configuration in a typesafe manner.
// When the dto is updated and the naming of the property does change, this will
// lead to compile errors which then helps us to identify such cases at build
// time instead of runtime.
export function typeField<T>(fieldName: keyof T) {
  return fieldName;
}

// Same like typeField but for nested properties/objects
export function typeFieldNested<T>(propertyFunction: (typeVal: T) => any): string {
  return getPropertyName(propertyFunction.toString());
}

export const getPropertyName = (propertyFunction: string): string => {
  let properties: string[] = [];

  if (propertyFunction) {
    const isArrowFunction = propertyFunction.toString().includes('=>');
    if (isArrowFunction) {
      // e.g. x => x.hero.address.postcode
      properties = propertyFunction.split('=>')[1].trim().split('.').splice(1);
    } else {
      // e.g. function(x) { return x.hero.address.postcode;}
      const step1 = propertyFunction.match(/return\s+([.a-zA-Z0-9]+)/i); // get the return part of the propertyFunction eg: return x.hero.address.postcode;
      const step2 = step1 && step1[1].match(/([a-z0-9_]+)/gi); // split the step1[1] text to return an array eg: ['x','hero','address','postcode']
      properties = (step2 && step2.splice(1)) || [];
    }
  }

  return properties.join('.');
};

export interface TypesafeChange<T> {
  previousValue?: T;
  currentValue: T;
  firstChange: boolean;
  isFirstChange(): boolean;
}
export type TypesafeChanges<T> = {
  [Key in keyof T]?: TypesafeChange<T[Key]>;
};
